import gql from 'graphql-tag'

export const GRAMMAR_ANALYZE = gql`
  mutation GrammarAnalyze(
    $recipients: [AnalyzeRecipient!]!
    $text: String!
    $options: GrammarAnalyzeOptions!
    $wtTraceId: String!
    $wtUploadId: String!
    $wtVariant: String!
    $wtFF: String
  ) {
    grammarAnalyze(
      recipients: $recipients
      text: $text
      options: $options
      wtTraceId: $wtTraceId
      wtUploadId: $wtUploadId
      wtVariant: $wtVariant
      wtFF: $wtFF
    ) {
      message {
        checker_types
      }
      error
    }
  }
`

export const PLAGIARISM_ANALYZE = gql`
  mutation PlagiarismAnalyze(
    $recipients: [AnalyzeRecipient!]!
    $text: String!
    $wtTraceId: String!
    $wtUploadId: String!
    $wtVariant: String!
  ) {
    plagiarismAnalyze(
      recipients: $recipients
      text: $text
      wtTraceId: $wtTraceId
      wtUploadId: $wtUploadId
      wtVariant: $wtVariant
    ) {
      message
      error
    }
  }
`



// WEBPACK FOOTER //
// ./src/queries/Analyze.ts